export default "__VITE_ASSET__D1AXF$aj__"